import React, { useContext } from "react";
import { useClubs } from "../../GlobalContext/selectedClubsContext";
import { OpenClubs } from "../../types";
import { getClubPhoto } from "../../utils/getMedia";
import { defaultImgs } from "../../utils/defaultImages";
import { SelectedGroupContext } from "../../GlobalContext/groupDetailContext";

interface ListOfClubsProps {
    allClubs: OpenClubs[];
    selectedOpenClubIds: string[];
    toggleSelectedOpenClub: (clubId: string) => void;
    cityName: string | undefined;
}

const ListOfClubs: React.FC<ListOfClubsProps> = ({
    allClubs,
    selectedOpenClubIds,
    toggleSelectedOpenClub,
    cityName,
}) => {

    const { selectedClubs, removeClub } = useClubs();

    // Filter out the selected clubs from the available clubs
    const filteredClubs = allClubs.filter(
        (club) => !selectedClubs.some((selectedClub) => selectedClub.id === club.ClubId)
    );

    const { requestedListing, offers } = useContext(SelectedGroupContext);

    const handleClubImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        const image = event.currentTarget;
        if (!image.dataset.fallback) {
            image.dataset.fallback = "1";
            image.src = defaultImgs.ClubImg;
        }
    };

    return (
        <>
            {selectedClubs.map((club) => (
                <div className="clubCon" key={club.id}>
                    <div className="form-check m-3 align-items-center col d-flex">
                        <input
                            className="form-check-input checkC shadow-none"
                            type="checkbox"
                            checked={true}
                            onChange={() => removeClub(club.id)}
                        />
                        <img
                            src={club.img || defaultImgs.ClubImg}
                            alt={club.name}
                            className="clubImg"
                            onError={handleClubImageError}
                        />
                        <div className="align-content-center col d-flex">
                            <label className="yellowTxt col text-left">
                                {club.name}
                            </label>
                        </div>
                    </div>
                </div>
            ))}

            {/* Display the list of other clubs */}
            {filteredClubs.map((club) => (
                <div className="clubCon" key={club.ClubId}>
                    <div className="form-check m-3 align-items-center col d-flex">
                        <input
                            className="form-check-input checkC shadow-none"
                            type="checkbox"
                            checked={selectedOpenClubIds.includes(club.ClubId)}
                            onChange={() => toggleSelectedOpenClub(club.ClubId)}
                            disabled={offers?.some(offer => offer.clubName === club.DisplayName) ?? false}
                        />
                        <img
                            src={
                                club.PictureUrl ??
                                getClubPhoto({
                                    clubName: club.ClubName,
                                    cityName: cityName ? cityName : "",
                                }) ??
                                defaultImgs.ClubImg
                            }
                            alt={club.DisplayName}
                            className="clubImg"
                            onError={handleClubImageError}
                        />
                        <div className="align-content-center col d-flex">
                            <label className="yellowTxt col text-left">
                                {club.DisplayName}
                                {requestedListing[0]?.clubName === club.DisplayName && !offers?.some(offer => offer.clubName === club.DisplayName) ? <p className="Req m-0">Requested</p> : ""}

                                {offers?.some(offer => offer.clubName === club.DisplayName) ?
                                    <p className="Req m-0">Already Offered</p> : ""}
                            </label>
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
};

export default ListOfClubs;
